import React from 'react';

// Components
import Button from '../../../../components/buttons/Button';
import Icon from '../../../../components/icons/Icon';
import MadeWithMilanoteUtil from '../../../../workspace/header/currentBoardHeader/madeWithMilanote/MadeWithMilanoteUtil';

// Types
import { ToolbarListType } from '../../../../workspace/toolbar/toolbarTypes';

const MobileGuestToolList: React.FC<{
    setDefaultToolbarType: (toolbarType: ToolbarListType) => void;
}> = ({ setDefaultToolbarType }) => {
    return (
        <div className="MobileTabsToolList">
            <div className="left">
                <Button
                    id="mobile-new-more-button"
                    className="mobile-util-button"
                    onClick={() => {
                        setDefaultToolbarType(ToolbarListType.MOBILE_GUEST_UTILS);
                    }}
                >
                    <Icon name="mobile-toolbar-more" />
                </Button>
            </div>

            <div className="center">
                <MadeWithMilanoteUtil />
            </div>
        </div>
    );
};

export default MobileGuestToolList;
